import { MapServerProvider } from 'providers/request'
import { InfowindowData } from 'models/infowindow'

export const InfowindowRepository = {
  fetch(id: number, layerId: number): Promise<InfowindowData> {
    return MapServerProvider.get(`/infowindow/${layerId}?idfeature=${id}`)
  },
}
